import instance from '../../api'

const BASE_ENDPOINT = '/api/admin/reverse_dcs'

export const getReverseDCList = (search) => instance.get(`${BASE_ENDPOINT}${search ? `?${search}` : ''}`)

export const updateReverseDC = (fields) => instance.put(`${BASE_ENDPOINT}/${fields.id}`, fields)

export const deleteReverseDC = (id) => instance.delete(`${BASE_ENDPOINT}/${id}`)

export const createReverseDC = (fields) => instance.post(BASE_ENDPOINT, fields)
